import './screen/arrayPolyfills'
import { ScreenId } from '@core/router'
import { renderScreen } from './screen/renderScreen'
import { AppLayoutContainer } from './navigation/AppLayoutContainer'
import { routes } from './navigation/routes'
import './screen/commonStyles'

renderScreen({
    routes,
    Layout: AppLayoutContainer,
    hydratedScreens: [
        ScreenId.MP3_CUTTER,
        ScreenId.AUDIO,
        ScreenId.AUTH,
        ScreenId.FORGOT_PASSWORD,
        ScreenId.BROWSE,
        ScreenId.COLLECTION,
        ScreenId.SEARCH,
        ScreenId.USER_AUDIO,
        ScreenId.USER_COLLECTIONS,
    ],
})
